module.exports = __webpack_public_path__ + "static/media/digisign-black.7e89de6d.png";